import Collection from './app-card-collection';
import Model from './app-card-model';

export default {
  Collection,
  Model,
  namespace: 'appCard',
};
